import { useEffect } from "react";
import { useSelector, useStore } from "react-redux";

import { isImpersonationSessionSelector } from "src/store/system/selector";
import { touchLastAccessedApi } from "src/apiService/modules/activity";
import { handleImpersonationRevokedError } from "src/utils/impersonationRevocation";
import type { AppState } from "src/store";

/** Ping cadence — between the spec's 10–15 minute window. */
const HEARTBEAT_MS = 12 * 60 * 1000;

/**
 * Mounted once inside the logged-in app shell (returns null). Records activity
 * on mount and on a timer: reseller sessions stamp `Users.last_accessed`,
 * accountant sessions stamp `Invitations.accountant_last_accessed`.
 */
function ActivityHeartbeat(): null {
  const store = useStore<AppState>();
  const isImpersonation = useSelector(isImpersonationSessionSelector);

  useEffect(() => {
    const ping = () => {
      touchLastAccessedApi(isImpersonation).catch((error) => {
        // Revoke is handled here as well as via the httpsCallable interceptor
        // (covers quiet tabs that only heartbeat).
        handleImpersonationRevokedError(error, store);
      });
    };
    ping();
    const timer = setInterval(ping, HEARTBEAT_MS);
    return () => clearInterval(timer);
  }, [isImpersonation, store]);

  return null;
}

export default ActivityHeartbeat;
